//MENU
const menuButton = document.getElementById("menu-button");
const menuLabel = document.getElementById("menu-label");
const menu = document.getElementById("menu");
const body = document.body;
const overlay = document.getElementById("overlay");

function toggleMenu() {
  if (!body.classList.contains("js-menu-open")) {
    body.classList.add("js-menu-open");
    menuButton.setAttribute("aria-expanded", "true");
    menuButton.setAttribute("aria-label", "閉じる");
    menu.inert = false;
    if (menuLabel) {
      menuLabel.textContent = "CLOSE";
    }
  } else {
    body.classList.remove("js-menu-open");
    menuButton.setAttribute("aria-expanded", "false");
    menuButton.setAttribute("aria-label", "メニュー");
    menu.inert = true;
    if (menuLabel) {
      menuLabel.textContent = "MENU";
    }
  }
}
if (menuButton) {
  menuButton.addEventListener("click", toggleMenu);
}
if (overlay) {
  overlay.addEventListener("click", toggleMenu);
}
// ハンバーガーメニュー内のリンクを取得
const menuLinks = document.querySelectorAll(".l-hamburger-menu__list li a");
// リンクがクリックされたらメニューを閉じる
menuLinks.forEach((link) => {
  link.addEventListener("click", () => {
    body.classList.remove("js-menu-open"); // メニューを閉じる
    menuButton.setAttribute("aria-expanded", "false");
    menuButton.setAttribute("aria-label", "メニュー");
    menu.inert = true;
    if (menuLabel) {
      menuLabel.textContent = "MENU";
    }
  });
});
//スマホ時アコーディオン
document.addEventListener('DOMContentLoaded', function() {
  // nolinkクラスを持つ要素を全て取得
  const nolinkElements = document.querySelectorAll('.nolink');
  // スマホ用メディアクエリ
  const mediaQuery = window.matchMedia('(max-width: 768px)');
  // メディアクエリが有効な場合にのみアコーディオンを機能させる
  if (mediaQuery.matches) {
    nolinkElements.forEach(function(nolinkElement) {
      nolinkElement.addEventListener('click', function() {
        // 次の兄弟要素を取得
        let sibling = nolinkElement.nextElementSibling;
        while (sibling && (sibling.classList.contains('child') || sibling.classList.contains('grandchild'))) {
          // 要素の表示をトグル
          if (sibling.style.display === 'block') {
            sibling.style.display = 'none';
          } else {
            sibling.style.display = 'block';
          }
          sibling = sibling.nextElementSibling;
        }
        // 親要素のクラスをトグル
        nolinkElement.classList.toggle('active');
      });
    });
  }
});
//TOPへ戻る
// セレクタ名（.pagetop）に一致する要素を取得
const pagetop_btn = document.querySelector(".l-footer-pagetop");
// .pagetopをクリックしたら
pagetop_btn.addEventListener("click", scroll_top);
// ページ上部へスムーズに移動
function scroll_top() {
  window.scroll({ top: 0, behavior: "smooth" });
}
// スクロールされたら表示
window.addEventListener("scroll", scroll_event);
function scroll_event() {
  if (window.pageYOffset > 300) {
    pagetop_btn.style.opacity = "1";
  } else if (window.pageYOffset < 100) {
    pagetop_btn.style.opacity = "0";
  }
}